import {useState,useEffect} from "react";
import Chart from "react-apexcharts";
import schedulePayService from '../../services/SchedulePayService';

const formatCurrency = (value) => {
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    }).format(value);
};

export default function CardV2({ year }) {
    const [totalsInvoice, setTotalsInvoice] = useState({
        withInvoice: 0,
        withOutInvoice: 0
    });

    useEffect(() => {
        schedulePayService.getTotalsByYear(year)
            .then(res => {
                setTotalsInvoice({
                    withInvoice: Number(res.data.withInvoice),
                    withOutInvoice: Number(res.data.withOutInvoice)
                });
            })
        .catch(console.error);
    }, [year]);

  const series = [
    {
      name: "Fatturato",
      data: [
        1200, // Gen
        1500, // Feb
        1100, // Mar
        1800, // Apr
        2000, // Mag
        2300, // Giu
        2100, // Lug
        1900, // Ago
        2500, // Set
        2700, // Ott
        3000, // Nov
        3400  // Dic
      ]
    }
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "55%"
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: [
        "Gen", "Feb", "Mar", "Apr", "Mag", "Giu",
        "Lug", "Ago", "Set", "Ott", "Nov", "Dic"
      ]
    },
    yaxis: {
      labels: {
        formatter: val => `${val.toLocaleString("it-IT")} €`
      }
    },
    tooltip: {
      y: {
        formatter: val => `${val.toLocaleString("it-IT")} €`
      }
    },
    colors: ["#4f46e5"]
  };
  	return (
        <div className="col-md-6 col-xxl-4 mb-6">
            <div className="card h-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title m-0 me-2">Sezione Tre</h5>
                </div>


    <Chart
      options={options}
      series={series}
      type="bar"
      height={320}
    />

        <Chart
            type="area"
            height={300}
            series={[
              {
                name: "Cash Flow",
                data: [300, 600, 400, 900, 1200, 1500]
              }
            ]}
            options={{
              xaxis: {
                categories: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu"]
              },
              dataLabels: { enabled: false }
            }}
          />

            </div>
        </div>
	);
}